export enum DocumentSide {

    Front,
    Back
}
